module.exports = __webpack_public_path__ + "media/story_video.500bc001.mp4";